import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
} from '@mui/material';
import LockIconWrapper from '../../../components/LockIconWrapper';

function UpsellSelectionDialog({
  open,
  onClose,
  availableUpsells,
  booking,
  onUpsellSelect,
  participantCount = 0,
}) {
  const getMinimumCount = upsell => {
    const value = Number(upsell?.upgrade?.minimumCount);
    return Number.isFinite(value) && value >= 0 ? Math.floor(value) : null;
  };

  const isBelowMinimumCount = upsell => {
    const minimumCount = getMinimumCount(upsell);
    return minimumCount !== null && Number(participantCount || 0) < minimumCount;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <LockIconWrapper right={'internalBooking:update:own'}>
          Verfügbare Zusatzleistungen
        </LockIconWrapper>
      </DialogTitle>
      <DialogContent>
        {availableUpsells &&
        availableUpsells.filter(
          upsell =>
            !booking.lineItems.some(
              item =>
                item.type === 'upsell' &&
                item.status === 'active' &&
                item.referenceId === upsell.upgradeId
            )
        ).length > 0 ? (
          <List>
            {availableUpsells
              .filter(
                upsell =>
                  !booking.lineItems.some(
                    item =>
                      item.type === 'upsell' &&
                      item.status === 'active' &&
                      item.referenceId === upsell.upgradeId
                  )
              )
              .map(upsell => (
                <ListItemButton
                  key={upsell?.upgradeId}
                  onClick={() => onUpsellSelect(upsell?.upgradeId)}
                  disabled={isBelowMinimumCount(upsell)}
                >
                  <ListItemText
                    primary={
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Typography variant='subtitle1'>
                          {upsell?.upgrade?.name || 'Unbekannter Upsell'}
                        </Typography>
                        <Typography variant='subtitle1' color='primary'>
                          {upsell?.upgrade?.price
                            ? `${upsell.upgrade.price.toFixed(2).replace('.', ',')} €`
                            : 'Preis nicht verfügbar'}
                        </Typography>
                      </Box>
                    }
                    secondary={
                      isBelowMinimumCount(upsell)
                        ? `Mindestens ${getMinimumCount(upsell)} Teilnehmer erforderlich`
                        : upsell?.upgrade?.descriptionShort ||
                          upsell?.upgrade?.description ||
                          'Keine Beschreibung verfügbar'
                    }
                  />
                </ListItemButton>
              ))}
          </List>
        ) : (
          <Box sx={{ textAlign: 'center', py: 2 }}>
            <Typography variant='body1' color='text.secondary'>
              Keine Zusatzleistungen verfügbar
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
              Alle verfügbaren Zusatzleistungen wurden bereits hinzugefügt oder es sind keine
              verfügbar.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
      </DialogActions>
    </Dialog>
  );
}

export default UpsellSelectionDialog;
